<template>
  <h1>Impressum</h1>
  <p>Beate-U bla bla</p>
</template>
